<template>
  <Container type="card-full">
    <div slot="header">
      <el-button @click="save" v-if="!isOk">确认</el-button>
      <vxe-button v-for="(btn) in this.$route.params.innerbtn" :key="btn.btncode" icon='el-icon-connection' status="">{{btn.btnname}}</vxe-button>
      <span class="status" v-if="isOk">报价已确认</span>
    </div>
    <vxe-table
      border
      :data="list">
      <vxe-table-column field="comfullname" title="供应商"></vxe-table-column>
      <vxe-table-column field="" title="报价次数">
        <template slot-scope="scope">
          <div>
            <div class="link" @click="pbrList(scope.row)">
              {{scope.row.pbrseq}}
            </div>
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column field="pbramt" title="报价金额"></vxe-table-column>
      <vxe-table-column title="附件">
        <template slot-scope="scope">
          <!--<div>{{scope.row.appendfilename}}</div>-->
          <div class="link" @click="downFile(scope.row.appendurl)">
            <a :src="$store.getters.uploadAddr + scope.row.appendurl">{{scope.row.appendfilename}}</a>
          </div>
        </template>
      </vxe-table-column>
      <!--<vxe-table-column field="appendfilename" title="附件" ></vxe-table-column>-->
      <vxe-table-column field="" title="审核状态">
        <template slot-scope="scope">
          <div v-if="isOk">{{scope.row.pbrconfirmstatusdesc}}</div>
          <div v-else>
            <el-select v-model="scope.row.pbrconfirmstatus" :clearable="true" placeholder="请选择">
              <el-option :key="2" value="2" label="审核通过"></el-option>
              <el-option :key="3" value="3" label="审核不通过"></el-option>
            </el-select>
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column  v-if="!isOk" field="" title="审核说明">
        <template slot-scope="scope">
          <div v-if="isOk">{{scope.row.pbrconfirmdesc}}</div>
          <div v-else>
            <el-input v-if="+scope.row.pbrconfirmstatus===3" v-model="scope.row.pbrconfirmdesc" :autosize="{ minRows: 2}" show-word-limit :maxlength="255" type="textarea" ></el-input>
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column field="pbrconfirmusername" title="审核人"></vxe-table-column>
      <vxe-table-column field="pbrconfirmtime" title="审核时间" formatter="toDateString"></vxe-table-column>
    </vxe-table>
    <!--<vggrid :list="list" tableheight="600" flexname="" :cols="cols"-->
    <!--:showfooter="false" :showPage="false" :resizable="true"></vggrid>-->
  </Container>
</template>
<script>
  import request from '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import common from '@/mixin/common'
  import utils from '../../assets/js/utils'

  export default {
    name: 'pbrConfirmForm',
    mixins: [common],
    data () {
      return {
        status: '',
        project: this.$route.params.form,
        list: [],
        btnLoading: false,
        cols: [
          {field: 'comfullname', fieldtype: 'C', title: '供应商', calculExpr: '', addNewRowFlg: false},
          {field: 'pbrseq', fieldtype: 'C', title: '报价次数', calculExpr: '', addNewRowFlg: false},
          {field: 'pbramt', fieldtype: 'C', title: '报价金额', calculExpr: '', addNewRowFlg: false},
          {field: 'appendfilename', fieldtype: 'C', title: '附件', calculExpr: '', addNewRowFlg: false},
          {field: 'username', fieldtype: 'C', title: '报价人', calculExpr: '', addNewRowFlg: false},
          {
            field: 'pbrtime',
            fieldtype: 'T',
            title: '报价时间',
            calculExpr: '',
            addNewRowFlg: false,
            formatter: ['toDateString', '']
          }
        ]
      }
    },
    created () {
      this.$on('CLOSE', () => this.close())
    },
    activated () {
      this.init()
      this.getPageList()
    },
    mounted () {
    },
    watch: {},
    components: {MenuBtn, vggrid},
    methods: {
      btnClick (code) {
        this.$emit(code)

      },
      async init () {
        this.project = this.$route.params.form
        this.list = []
        this.btnLoading = false
      },
      async pbrList (item) {
        this.$router.push({name: 'pbrListForm', params: {comid: item.pbrcomid, form: this.project, type: 1}})
      },
      async save () {
        let nowdate = await request({
          method: 'get',
          url: 'xtgl/sysdata'
        })
        if (+this.project.projectstatus > 30) {
          this.$message.warning(`项目已进入${this.project.projectstatusname}不能审核报价确认!`)
          return
        }
        if (new Date(nowdate).getTime() < new Date(this.project.prsbjendtime).getTime()) {
          this.$message.warning('报价时间尚未结束，不能确认!')
          return
        }
        let pexpertList = await request({
          url: '/xmgl/project/getPexpertList',
          method: "get",
          params: {projectid: this.project.projectid}
        })
        if (+this.project.projectdoneflg !== 1 &&!pexpertList.length) {
          this.$message.warning('请抽取评审人!')
          setTimeout(() => {
            this.$router.push({name: 'pexpertForm', params: {form: this.project, type: 2}})
          }, 900)
          return
        }
        let confirmsList = this.list.filter(v => +v.pbrconfirmstatus === 2)
        if (+this.project.prssupplynums > 0 && confirmsList.length < +this.project.prssupplynums) {
          this.$message.warning(`有效报名的供应商家数不能小于项目设置的有效报名家数（${this.project.prssupplynums}家）!`)
          return
        }
        let model = {
          projectid: this.project.projectid,
          projectdoneflg: this.project.projectdoneflg,
          userid: this.$store.getters.loginUser.userid,
          list: this.list
        }
        let index = this.list.findIndex(v => !v.pbrconfirmstatus)
        if (index > -1) {
          this.$message.warning('请选择审核状态!')
          return
        }
        index = this.list.findIndex(v => +v.pbrconfirmstatus === 3 && !v.pbrconfirmdesc)
        if (index > -1) {
          this.$message.warning('请输入审核说明!')
          return
        }
        let data = await request({
          url: '/xmgl/project/confirmPbr',
          method: "post",
          data: model
        })
        if (data.issuccess === 1) {
          this.$message.success('报价确认成功')
          this.getPageList()
        } else {
          this.$message.error('报价确认失败!' + data.msg)
        }
      },
      async close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'pbrConfirmIndex'})
      },
      async getPageList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/xmgl/project/getPbrListByProjectid',
          params: {projectid: this.project.projectid}
        })
        res.forEach(key => {
          key.pbramt = utils.comdify(key.pbramt)
          key.pbrconfirmstatus = +key.pbrconfirmstatus === 1 ? '' : key.pbrconfirmstatus
        })
        this.list = res
        this.loading = false
      }
    },
    filters: {},
    computed: {
      isOk () {
        return this.list.length && +this.list[0].projectstatus >= 40
      }
    }
  }
</script>
<style lang="scss">
  .status {
    color: red;
    padding-left: 10px;
  }

  .link {
    color: #2f74ff;
    cursor: pointer;
  }

  .tagout {
    display: flex;
    justify-content: center;
    .tag {
      color: #2f74ff;
      cursor: pointer;
      width: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 1px solid #DDDDDD;
      border-radius: 5px;
    }
  }
</style>
